import styles from "../../../styles/Components/new-dashboard/AccountSummary.module.css";
import { Skeleton } from "antd";
import { formatPrice } from "../../../utility/helper";
import DashboardContentBox from "../DashboardContentBox";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";
import ChargeCreditModal from "../../../shared/ChargeCreditModal";
import CartIcon from "../../../ui/icons/CartIcon";

function AccountBalance() {
  const {
    profile: { profileData, error, loading },
  } = useSelector((state) => state);
  const [showChargeCreditModal, setShowChargeCreditModal] = useState(false);

  // const navigate = useNavigate();

  return (
    <DashboardContentBox
      className={styles.box}
      // onClick={() => navigate("/pricing-billing/credit")}
      onClick={() => setShowChargeCreditModal(true)}
    >
      <span
        className={styles.inviteBtn}
        onClick={(e) => {
          e.stopPropagation();
          setShowChargeCreditModal(true);
        }}
      >
        <FaPlus size={13} />
      </span>
      <span className={styles.boxIcon}>
        {/*<BsCreditCard />*/}
        <CartIcon />
      </span>
      <h5>Account Balance</h5>
      {loading ? (
        <Skeleton.Input active />
      ) : error ? (
        "-"
      ) : (
        <span className={styles.info}>
          {/*Credit: */}
          {`$${formatPrice(profileData?.credit / 100)}`}
        </span>
      )}
      <ChargeCreditModal
        open={showChargeCreditModal}
        onClose={() => setShowChargeCreditModal(false)}
      />
    </DashboardContentBox>
  );
}

export default AccountBalance;
